import { Injectable } from '@angular/core';

import { PageBlock} from '../index';
import { PageNode } from '../index';
import {ImageBlock, Layout, Size} from './image-block.model';
import {TextBlock} from './text-block.model';
import {Page} from '../index';
import {environment} from '@Env/environment';


@Injectable({   providedIn: 'root' })
export class PageHelper {
  constructor(
  ) { }

  /**
   * Tri de pages sur la propriété order
   * si order = 0 (non initialisé) alors on met arbitrairement 100 pour les mettres à la fin
   * @param pages
   */
  sortPages(pages: PageNode[]) {
    if (pages) {
      pages.sort((p1: PageNode, p2: PageNode) => {
        const order1 = p1.data.order ? p1.data.order : 100;
        const order2 = p2.data.order ? p2.data.order : 100;
        return order1 - order2;
      });
    }
  }

  /**
   * Tri des pages par leur titre
   * @param pages
   * @param direction
   */
  sortPagesByTitle(pages: PageNode[], direction = 'asc') {
    if (pages) {
      pages.sort((p1: PageNode, p2: PageNode) => {
        return (p1.data.title.toLowerCase() < p2.data.title.toLowerCase() ? -1 : 1) * (direction === 'asc' ? 1 : -1);
      });
    }
  }

  /**
  Construction récursive de l'arbo des pages pour le tree component, setting de quelques propriétés
  page.data.properties => page.properties

  Searches for id in PageNode[] tree and returns the parent node that contains a child with this id
  Saves the title of the page in page.name (required for angular2-tree)

  Tri des pages sur order
  */
  calculateCurrentPageTree(excludeNoPublished = false,
                           pages: PageNode[], id: number,
                           expandLevels: number = 0, level: number = 1): PageNode {
    if (! pages) {
      return null;
    }

    let found = null;

    this.sortPages(pages);

    for (const page of pages) {
      if ((excludeNoPublished && page.data.is_published) || (! excludeNoPublished)) {
        page.name = page.data.title;
        page.is_published = page.data.is_published;
        page.order = page.data.order;
        page.is_favourite = page.data.is_favourite;

        if (expandLevels > 0 && expandLevels >= level && page.children) {
          page.isExpanded = true;
        }
        const p = this.calculateCurrentPageTree(excludeNoPublished, page.children, id, expandLevels, level + 1);
        if (p || page.id === id) {
          found = page;
        }
      }
    }

    return found;
  }

  newBlock(type: string): PageBlock {
    let block: PageBlock = null;

    switch (type) {
      case 'image':
        block = this.newImageBlock();
        break;
      default:
      case 'text':
        block = this.newTextBlock();
        break;
    }

    return block;
  }

  calculeUrlImage(block: ImageBlock) {
    if (block && block.value && block.value.file) {
      return block.value.file;
    }

    return '';
  }

  newTextBlock(): TextBlock {
    return {
      type: 'text',
      value: ''
    };
  }

  newImageBlock(): ImageBlock {
    return {
      type: 'image',
      value: { imageId: 0, layout: <Layout> {}, size: <Size>{}, file: ''}
    };
  }

  getSlug(page: Page, bdcApp = 'bdc/') {
    let url = '';

    if (page && page.slug) {
      const env = environment.env;

      const tls = `${env === 'dev' ? 'http' : 'https'}`;
      const appBase = `${env === 'dev' ? '' : bdcApp}`;

      url = `${tls}://${window.location.hostname}/${appBase}page/${page.slug}`;
    }

    return url;
  }
}
